__turbopack_context__.v({
  "root": "PlasmicBullet-module__4-vxxq__root",
  "rootactive": "PlasmicBullet-module__4-vxxq__rootactive",
  "sliderNavigationBullet": "PlasmicBullet-module__4-vxxq__sliderNavigationBullet",
  "sliderNavigationBulletactive": "PlasmicBullet-module__4-vxxq__sliderNavigationBulletactive",
});
